import type { Role } from '@dd/shared';

/** Who is operating this device right now. Set by the session store; read by the outbox and the sync engine. */
export interface SyncContext {
  shopId: string;
  deviceId: string;
  deviceCode: string | null;
  role: Role;
  actor: { type: 'owner' | 'staff'; id: string };
  accountId: string;
}
let ctx: SyncContext | null = null;
export const setSyncContext = (c: SyncContext | null): void => { ctx = c; };
export const syncContext = (): SyncContext => {
  if (!ctx) throw new Error('not signed in');
  return ctx;
};
export const hasSyncContext = (): boolean => ctx !== null;
